import { ca } from '@cian/analytics';
export function trackNextButtonClick(_ref) {
  var licenceAccepted = _ref.licenceAccepted,
      marketingSubscriptionAccepted = _ref.marketingSubscriptionAccepted;
  var labelsRaw = [];

  if (licenceAccepted) {
    labelsRaw.push('terms');
  }

  if (marketingSubscriptionAccepted) {
    labelsRaw.push('ads');
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'UserAgreement',
    action: 'click_continue',
    label: labelsRaw.join('_')
  });
}